import { Swiper } from "swiper";
import { Autoplay, Navigation } from 'swiper/modules';
import { BREAKPOINT_SM, BREAKPOINT_MD, BREAKPOINT_LG } from "../globals";

const SLIDES_PER_VIEW_SM = 1;
const SLIDES_PER_VIEW_MD = 2;
const SLIDES_PER_VIEW_LG = 2.5;

export default class SliderQuotes {
    static init(swiperContainer) {
        return new SliderQuotes(swiperContainer);
    }

    static initAll() {
        const swiperContainers = document.querySelectorAll('.quotes-slider');
        return swiperContainers.forEach(swiperContainer => SliderQuotes.init(swiperContainer));
    }

    constructor(swiperContainer) {
        const swiperElement = swiperContainer.querySelector('.swiper');

		if (swiperElement === null) return;

		/** @var {SwiperOptions} */
		const config = {
			modules: [Autoplay, Navigation],
			slidesPerView: 2,
			breakpoints: {
				[BREAKPOINT_SM]: {
					slidesPerView: SLIDES_PER_VIEW_SM,
				},
				[BREAKPOINT_MD]: {
					slidesPerView: SLIDES_PER_VIEW_MD,
				},
				[BREAKPOINT_LG]: {
					slidesPerView: SLIDES_PER_VIEW_LG,
				}
			},
			speed: 1000,
			autoplay: {
				delay: 40000, // in miliseconds
				disableOnInteraction: false,
			},
			grabCursor: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            spaceBetween: 50,
            centerSlides: true,
            centerInsufficientSlides: true,
		};

		this.slider = new Swiper(swiperElement, config);
    }
}